import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { catchError, of } from "rxjs";

import { AuthService } from '../../services/auth.service';
import { NotificationsService } from "../../services/notifications.service";
import { NotificationRequest } from "../../models/notification.model";
import { formatSubmissionDate } from "../../utils/utils";

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrl: './contact-modal.component.scss',
})
export class ContactUsModalComponent {
  message: string = '';
  isSending = false;
  submissionSuccess = false;
  redirectTime = 5;
  redirectInterval: any;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private router: Router,
    private notificationsService: NotificationsService,
  ) {}
  
  send() {
    this.isSending = true;
    const emailId = this.authService.getCurrentUser()?.email;
    const currentUrl = this.router.url;

    const notificationRequest: NotificationRequest = {
      triggerEvent: "contact_us_form_submission",
      channel: "email",
      mailingListName: "coordinator-notifications",
      priority: "high",
      data: {
        emailId,
        submissionDate: formatSubmissionDate(new Date()),
        message: this.message,
        currentUrl: currentUrl
      },
    };

    this.notificationsService
      .sendNotification(notificationRequest)
      .pipe(
        catchError((error) => {
          console.error("Notification failed, but continuing:", error);
          return of(null);
        })
      )
      .subscribe((response) => {
        console.log("Notification response:", response);
        this.isSending = false;
        this.submissionSuccess = true;
        this.startCountdown();
      });
  }

  startCountdown() {
    this.redirectInterval = setInterval(() => {
      this.redirectTime--;
      if (this.redirectTime <= 0) {
        clearInterval(this.redirectInterval);
        this.activeModal.close();
      }
    }, 1000);
  }

}
